// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.edit-section > div[data-v-59233ff0]{\n  margin-bottom: 1rem;\n}\n.first-fields[data-v-59233ff0] {\n  -webkit-box-flex: 2;\n      -ms-flex: 2;\n          flex: 2;\n  margin-right: 2rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
